// ///////////////////////////
// Shipping Map information //
// ///////////////////////////

// STANDARD(1, "Standard Shipping"),
// TWO_DAY(2, "Two-Day Shipping"),
// ONE_DAY_EXPRESS(3, "One-Day Express Shipping"),
// CANADIAN_AIR(4, "Canadian Air Parcel Post"),
// INTERNATIONAL_AIR(5, "International Air Shipping"),
// EMPLOYEE_ORDER(200, "Employee Order Shipping"),
// NOT_APPLICABLE(201, "Shipping Not Applicable (for eGC)"),
// GIFT_CARD_AND_MEMBERSHIP(202, "Physical Gift Card and Membership Shipping"),
// SHIP_TO_STORE(203, "Ship-to-Store"),
// GIFT_CARD_EXPRESS(204, "Gift Card Express Shipping"),
// GIFT_CARD_TWO_DAY(205, "Gift Card 2-Day Shipping"),
// FREIGHT(206, "Freight");

export default {
  STANDARD: 1,
  TWO_DAY: 2,
  ONE_DAY_EXPRESS: 3,
  CANADIAN_AIR: 4,
  INTERNATIONAL_AIR: 5,
  EMPLOYEE_ORDER: 200,
  NOT_APPLICABLE: 201,
  GIFT_CARD_AND_MEMBERSHIP: 202,
  SHIP_TO_STORE: 203,
  GIFT_CARD_EXPRESS: 204,
  GIFT_CARD_TWO_DAY: 205,
  FREIGHT: 206,
  1: 'STANDARD',
  2: 'TWO_DAY',
  3: 'ONE_DAY_EXPRESS',
  4: 'CANADIAN_AIR',
  5: 'INTERNATIONAL_AIR',
  200: 'EMPLOYEE_ORDER',
  201: 'NOT_APPLICABLE',
  202: 'GIFT_CARD_AND_MEMBERSHIP',
  203: 'SHIP_TO_STORE',
  204: 'GIFT_CARD_EXPRESS',
  205: 'GIFT_CARD_TWO_DAY',
  206: 'FREIGHT',
}
